export default {"src":"/_next/static/media/dog-friendly.f0d9fa90.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};